import { graphql } from 'gatsby';
import { StyledInfoTag } from './InfoTag.styles';

export type InfoTagColor = Queries.INFO_TAGFragment['elements']['color']['value'];
export type InfoTagSize = 'small' | 'large';

interface InfoTagProps extends Queries.INFO_TAGFragment {
  size?: InfoTagSize;
}

const InfoTag = ({ elements: { text, color }, size = 'large' }: InfoTagProps) => {
  return (
    <StyledInfoTag tagColor={color.value} tagSize={size}>
      {text.value}
    </StyledInfoTag>
  );
};

export const fragment = graphql`
  fragment INFO_TAG on kontent_item_info_tag {
    system {
      id
    }
    elements {
      text {
        value
      }
      color {
        value
      }
    }
  }
`;

export default InfoTag;
